import type { FocusWindowBox } from "@/lib/focus-window-layout";

const CONVERSATION_FOCUS_WIDTH = 400;
const CONVERSATION_FOCUS_HEIGHT = 720;
const CONVERSATION_FOCUS_RIGHT_INSET = 48;
const CONVERSATION_FOCUS_LEFT_INSET = 24;
const CONVERSATION_FOCUS_VERTICAL_INSET = 24;
const CONVERSATION_FOCUS_GAP = 2;

export function calculateConversationFocusBoxes(
  surface: FocusWindowBox,
  count: number,
): FocusWindowBox[] {
  const safeCount = Math.max(1, Math.floor(count));
  const horizontalSpace = Math.max(
    1,
    surface.width -
      CONVERSATION_FOCUS_RIGHT_INSET -
      CONVERSATION_FOCUS_LEFT_INSET -
      CONVERSATION_FOCUS_GAP * (safeCount - 1),
  );
  const width = Math.min(
    CONVERSATION_FOCUS_WIDTH,
    Math.max(1, Math.floor(horizontalSpace / safeCount)),
  );
  const height = Math.min(
    CONVERSATION_FOCUS_HEIGHT,
    Math.max(1, surface.height - CONVERSATION_FOCUS_VERTICAL_INSET * 2),
  );
  const right = surface.x + surface.width - CONVERSATION_FOCUS_RIGHT_INSET;
  const y = Math.round(surface.y + (surface.height - height) / 2);

  return Array.from({ length: safeCount }, (_, index) => ({
    x: Math.round(right - width - index * (width + CONVERSATION_FOCUS_GAP)),
    y,
    width,
    height,
  }));
}
